/**
 * @class
 * @param {AitiProductVariants} variants
 */
var AitiProductVariantsSelection = function(variants) {

    let _this = this;

    this.variants = variants;
    this.productAddToCartForm_submitOld = null;

    this.getVariants = function() {
        return this.variants;
    };

    /** @returns {AitiProductView} */
    this.getView = function() {
        return this.getVariants().getView();
    };

    this.updateGroup = function() {
        $j(AitiProductVariantsSelection.SELECTOR_GROUP).toggleClass('checked', false);
        $j(AitiProductVariantsSelection.SELECTOR_OPTIONS).toggleClass('show', false);

        let group = this.getVariants().getCurrentGroup();
        if (group) {
            $j(AitiProductVariantsSelection.SELECTOR_GROUP + '[data-id=' + group.getId() + ']').toggleClass('checked', true);
            $j(AitiProductVariantsSelection.SELECTOR_OPTIONS + '[data-group-id=' + group.getId() + ']').toggleClass('show', true);

            $j('.imageContainer[data-id=' + group.getId() + '] img').trigger('click'); //quick solution using old variant selection
        }
    };

    this.updateGroupOption = function() {
        let option = this.getVariants().getCurrentGroupOption();

        $j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_OPTION).toggleClass('selected', false);

        if (option) {
            let $options = $j(AitiProductVariantsSelection.SELECTOR_OPTIONS + '[data-group-id=' + option.getGroup().getId() + ']');
            $j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT).toggleClass('selected', true);
            $j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_BUTTON + ' span', $options).html(option.getLabel());
            $j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_OPTION + '[data-id=' + option.getId() + ']').toggleClass('selected', true);

            $j('.optionSize#' + option.getItemId()).trigger('click'); //quick solution using old variant selection
        } else {
            $j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT).toggleClass('selected', false);
            $j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_BUTTON + ' span').html($j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_BUTTON).attr('data-placeholder'));
        }

        this.hideSelectWarning();
    };

    this.showSelectWarning = function() {
        this.hideSelectWarning();

        let group = this.getVariants().getCurrentGroup();
        if (group) {
            $j(AitiProductVariantsSelection.SELECTOR_OPTIONS + '[data-group-id=' + group.getId() + '] ' + AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT).toggleClass('error2', true);
        }
    };

    this.hideSelectWarning = function() {
        $j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT).toggleClass('error2', false);
    };

    this.open = function() {
        let group = this.getVariants().getCurrentGroup();
        if (group) {
            let $select = $j(AitiProductVariantsSelection.SELECTOR_OPTIONS + '[data-group-id=' + group.getId() + '] ' + AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT);
            $select.toggleClass('open');

            if ($select.hasClass('open')) {
                let $options = $select.find(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_OPTIONS);
                let $selectedOption = $options.find(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_OPTION + '.selected');
                if ($selectedOption.length == 1) {
                    if ($options.height() < ($selectedOption.position().top + $selectedOption.outerHeight())) {
                        $options.scrollTop($selectedOption.position().top + $selectedOption.outerHeight() - $options.height() + $options.scrollTop());
                    }
                }
                AitiCore.getUtils().scrollToInvisibleElement($options, 150, 100);
            }
        }
    };

    this.close = function() {
        $j(AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT).toggleClass('open', false);
    };

    this.getVariants().onInitAfter(function() {
        $j(document).on('click', AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_BUTTON, function(event) {
            event.stopPropagation();
            _this.open();
        });

        $j(document).on('click', AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_OPTIONS, function(event) {
            event.stopPropagation();
        });

        $j(document).on('click', AitiProductVariantsSelection.SELECTOR_GROUP, function() {
            _this.getVariants().changeGroup($j(this).attr('data-id'));
        });

        $j(document).on('mouseover', AitiProductVariantsSelection.SELECTOR_GROUP, function() {
            hoverFunctionGrouped($j('.imageContainer[data-id=' + $j(this).attr('data-id') + '] img')); //quick solution using old variant selection
        });

        $j(document).on('mouseout', AitiProductVariantsSelection.SELECTOR_GROUP, function() {
            hoverOffFunctionGrouped($j('.imageContainer[data-id=' + $j(this).attr('data-id') + '] img')); //quick solution using old variant selection
        });

        $j(document).on('click', AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_OPTION, function() {
            _this.getVariants().changeGroupOption($j(this).attr('data-id')).done(function() {
                _this.close();
            });
        });

        $j(document).on('click', function() {
            _this.close();
        });

        $j(document).on('keyup', function(event) {
            if (event.which == 27) { //escape
                _this.close();
            }
        });

        if (window.productAddToCartForm) {
            _this.productAddToCartForm_submitOld = window.productAddToCartForm.submit;

            window.productAddToCartForm.submit = function() {
                if (!_this.getVariants().getCurrentGroupOption()) {
                    _this.showSelectWarning();
                    setTimeout(function() {
                        _this.open();
                    });
                    return false;
                }

                _this.productAddToCartForm_submitOld();
            };
        }
    });
};

/** SELECTORS */
AitiProductVariantsSelection.SELECTOR_GROUP = '[data-js=product-variants-selection-group]';
AitiProductVariantsSelection.SELECTOR_OPTIONS = '[data-js=product-variants-selection-options]';
AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT = '[data-js=product-variants-selection-options-select]';
AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_BUTTON = '[data-js=product-variants-selection-options-select-button]';
AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_OPTIONS = '[data-js=product-variants-selection-options-select-options]';
AitiProductVariantsSelection.SELECTOR_OPTIONS_SELECT_OPTION = '[data-js=product-variants-selection-options-select-option]';

export default AitiProductVariantsSelection;
